import { createRouter, createWebHashHistory, RouteRecordRaw, createWebHistory } from "vue-router";
import store from "@/store";
import { Mutations, Actions, Menu, Users } from "@/store/enums/StoreEnums";
import { CookieComponent } from "@/assets/ts/components";
import {
  setCurrentPageBreadcrumbs,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import JwtService from "@/core/services/JwtService";
import { formatUserMenu } from "@/utils/userMenuUtil";
import { menu, route } from "@/core/types";
import { getIFramePath, getIFrameUrl } from "@/utils/iframe";
import { App } from "vue";
const defaultRoutes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "chatBot",
    component: () =>
      import("@/views/ChatBot.vue"),
  }/* ,
  {
    path: "/:pathMatch(.*)*",
    redirect: "/404",
  }, */
];

const router = createRouter({
  history: createWebHistory(),
  routes: defaultRoutes,
});

const check = (text) => {
  return router.currentRoute.value.fullPath.includes(text);
};

router.beforeEach(async (to, from, next) => {

  if ( to.fullPath !== "/"
  ) {
    next({ path: "/" });
  } else {
    next()
  }

  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

/* breadcrumb */
router.afterEach((to, from, failure) => {
  if (to.fullPath.includes("dashboard")) {
    setCurrentPageTitle("Dashboard");
  } else {
    const path = to.fullPath.substring(1).split("/");
    const length = path.length;
    let pathRoot = [] as string[];
    if (length > 1)
      pathRoot = to.fullPath
        .substring(1)
        .split("/")
        .splice(0, length - 1);
    setCurrentPageBreadcrumbs(path[length - 1], pathRoot);
  }
});

function handleStaticComponent(router, dynamicRoutes) {
  for (let j = 0; j < dynamicRoutes.length; j++) {
    if (dynamicRoutes[j].name == 'Code generation') {
      dynamicRoutes[j].component = {} as Generator;
      break
    }
  }
  router.options.routes[0].children = router.options.routes[0].children.concat(dynamicRoutes)
}

function handleIFrameUrl(path) {
  //Nested pages, save iframeUrl to store for IFrame component to read and display
  let url = path;
  let length = store.state.iframe.iframeUrls.length;
  for (let i = 0; i < length; i++) {
    let iframe = store.state.iframe.iframeUrls[i];
    if (path != null && path.endsWith(iframe.path)) {
      url = iframe.url;
      store.commit('setIFrameUrl', url);
      break
    }
  }
}

async function routerInit(app: App) {
  try {

    app.use(router);
  } catch (error) {
    console.error("Tìm kiếm menu thất bại: ", error);
  }
}

export default router;
export { routerInit }

